import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, effect, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { Router, RouterModule } from '@angular/router';
import { ProjectService } from '../services/project.service';
import { ClientService } from '../services/client.service';
import { AuthService } from '../services/auth.service';
import { APIUrl } from '../constant/api-call';
import { Excelservice } from '../services/excel.service';

@Component({
  selector: 'app-form-reports.component',
  standalone: true,
  imports: [CommonModule, PrimeNgModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './form-reports.component.html',
  styleUrl: './form-reports.component.css',
})
export class FormReportsComponent implements OnInit {
  public commonDataObject = {
    APIObj: APIUrl,
    displayDialog: false,
    issuccessAlert: false,
    iserrorAlert: false,
    apiMeassge: '',
    filterData: [] as any[],
    selected_form: {} as any,
    selectedFormFields: [] as any,
    tableKeys: [] as string[],
    selectedFilters: {} as any,
    summaryData: {} as any
  }
  activeTabIndex: number = 0;
  public chartData: { [key: string]: any } = {};
  public chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1.6,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          boxWidth: 20,
          padding: 5,
          font: {
            size: 11
          }
        }
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
            return `${label}: ${this.formatValue(value)} (${percentage}%)`;
          }
        }
      }
    },
    cutout: '0%',
    elements: {
      arc: {
        borderWidth: 2,
        borderColor: '#ffffff'
      }
    }
  };
  public dialogHeader: string = 'Submission Form';
  public showResetFromAnalytics = false;
  public dataFromAnalytics: any;
  public formOptions: any;
  public redirect = false;
  public isLoading = false;
  public currentFilterYearValue: any[] = [];
  public currentFilterOnYears = '';
  public currentFilterYearKey: any;
  public excelExportPopup = false;
  public selectedFormat: 'years' | 'months' | null = null;
  public formulaOptions: any[] = [];
  public formulaRawList: any[] = [];
  public formulaViews: any[] = [];
  public formulaChartOptions: any = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1.6,
    plugins: {
      legend: {
        position: 'right',
        labels: { boxWidth: 20, padding: 5, font: { size: 11 } }
      },
      tooltip: {
        callbacks: {
          label: (ctx: any) => {
            const real = ctx.dataset.realValues?.[ctx.dataIndex] ?? ctx.raw;
            return `${ctx.label}: ${this.formatValue(real)}`;
          }
        }
      }
    },
    cutout: '0%',
    elements: { arc: { borderWidth: 2, borderColor: '#ffffff' } }
  };

  constructor(
    public projectService: ProjectService,
    private clientService: ClientService,
    public authService: AuthService,
    private excelService: Excelservice,
    private cdr: ChangeDetectorRef,
    public router: Router
  ) {
    let data: any = this.projectService.getReportData();
    this.isLoading = true;
    if (data?.length > 0 || data !== null) {
      setTimeout(async () => {
        this.redirect = true;
        this.dataFromAnalytics = { form_id: data?.form_id, values: data?.values };
        this.commonDataObject.filterData = await this.projectService.getFormReportData();
        if (this.commonDataObject.filterData.length > 0) {
          const selectedForm = this.commonDataObject.filterData?.filter((e: any) => {
            return e.form_id === this.dataFromAnalytics?.form_id;
          });

          if (selectedForm && selectedForm[0]) {
            this.commonDataObject.selected_form = selectedForm[0];
            this.commonDataObject.selectedFormFields = selectedForm[0]?.fields?.filter((field: any) => Array.isArray(field.field_values) && field.field_values.length && field?.field_id !== 1068);
            this.commonDataObject.selectedFormFields?.forEach((e: any) => {
              if (e?.field_values?.length > 0) {
                e.field_values = e?.field_values?.filter((obj: any) => Object.keys(obj)?.length > 0);
              }
              if (e?.field_label?.toLowerCase() == 'year' || e?.field_label?.toLowerCase() == 'years') {
                this.currentFilterYearKey = e?.field_id;
              }
            })
            if (data?.values?.length) {
              data.values.forEach((item: any) => {
                const rawValues = item.values;
                const matchedField = this.commonDataObject.selectedFormFields.find(
                  (f: any) => f.field_id === item.field_id
                );
                const incomingArray: any[] = Array.isArray(rawValues)
                  ? rawValues
                  : rawValues?.toString().split(',').map((v: string) => v.trim());

                let matchedValues: any[] = incomingArray;

                if (matchedField?.field_values?.length) {
                  matchedValues = incomingArray
                    .map((incoming: any) => {
                      const match = matchedField.field_values.find((opt: any) =>
                        opt?.value?.toString().trim().toLowerCase() ===
                        incoming?.toString().trim().toLowerCase()
                      );
                      return match ? match.value : null;
                    })
                    .filter((v: any) => v !== null);
                }

                this.commonDataObject.selectedFilters[item.field_id] = matchedValues;
              });
            }
            this.getSummaryData(this.dataFromAnalytics);
            this.showResetFromAnalytics = true;
            this.cdr.detectChanges();
            this.redirect = false;
          }
        }
        // this.isLoading = false;
      }, 100);
    }
    effect(async () => {
      this.projectService.getMasterData();
      this.isLoading = true;
      setTimeout(async () => {
        const forms = this.projectService.getFormList();
        await this.autoSelectSingleForm(forms);
        // this.isLoading = false;
      }, 1000)
    })
  }

  async autoSelectSingleForm(forms: any) {
    if (forms?.length > 0 && (!this.commonDataObject.selected_form || !Object.keys(this.commonDataObject.selected_form).length)) {
      this.commonDataObject.selected_form = forms[0];
      if (this.commonDataObject.selected_form?.form_id) {
        this.onFormChange('UI');
      }
    }
  }

  async ngOnInit() {
    this.projectService.getMasterData();
    this.projectService.loading.set(true);
    setTimeout(async () => {
      this.commonDataObject.filterData = await this.projectService.getFormReportData();
      const projectId = this.projectService.selectedProject()?.project_id;
      if (projectId) {
        await this.projectService.getFormsProjectWise(projectId);
      }
      this.projectService.loading.set(false);
    }, 300)
  }

  onFormNameChange(name: any) {
    this.dialogHeader = name;
  }

  onFormChange(flag?: any) {
    const selectedForm = this.commonDataObject?.filterData?.find(f => f.form_id === this.commonDataObject.selected_form?.form_id);
    this.commonDataObject.selected_form = selectedForm;
    this.commonDataObject.selectedFormFields = selectedForm ? selectedForm.fields?.filter((field: any) => Array.isArray(field?.field_values) && field?.field_values?.length && field?.field_id !== 1068) : [];
    this.commonDataObject.selectedFormFields?.forEach((e: any) => {
      if (e?.field_values?.length > 0) {
        e.field_values = e?.field_values?.filter((obj: any) => Object.keys(obj)?.length > 0);
      }
      if (e?.field_label?.toLowerCase() == 'year' || e?.field_label?.toLowerCase() == 'years') {
        this.currentFilterYearKey = e?.field_id;
      }
    })
    this.commonDataObject.selectedFilters = {};
    this.commonDataObject.selectedFormFields?.forEach((field: any) => {
      this.commonDataObject.selectedFilters[field.field_id] = [];
    });
    this.commonDataObject.summaryData = {};
    this.commonDataObject.tableKeys = [];
    this.chartData = {};
    this.formulaViews = [];
    if (flag === 'UI') {
      if (this.commonDataObject.selected_form?.form_id) {
        this.generatePayload();
      }
    }
    this.cdr.detectChanges();
    this.cdr.markForCheck();
  }

  generatePayload() {
    const payload = {
      form_id: this.commonDataObject.selected_form?.form_id,
      values: Object.keys(this.commonDataObject.selectedFilters)
        .filter(fieldId => this.commonDataObject.selectedFilters[fieldId]?.length)
        .map(fieldId => ({
          field_id: Number(fieldId),
          values: this.commonDataObject.selectedFilters[fieldId].join(',')
        }))
    };
    this.getSummaryData(payload);
    this.getParameter();
  }

  getParameter() {
    let projectId: any = sessionStorage.getItem('selected_project');
    if (projectId) {
      projectId = JSON.parse(projectId);
    }
    const payload = {
      project_id: projectId?.project_id,
      selected_filters: Object.keys(this.commonDataObject.selectedFilters)
        .filter(fieldId => this.commonDataObject.selectedFilters[fieldId]?.length)
        .map(fieldId => ({
          field_id: Number(fieldId),
          value: this.commonDataObject.selectedFilters[fieldId].join(',')
        }))
    };
    this.clientService.postAPI(this.commonDataObject.APIObj.REPORT_PARAMETER, payload).subscribe(
      (res: any) => {
        if (res && res.code == 'CSR_MS_OK_200') {
          const filterForm = res.data?.filter((e: any) => e?.form_id === this.commonDataObject.selected_form?.form_id);
          if (filterForm?.length > 0) {
            this.commonDataObject.selectedFormFields = filterForm[0]?.fields;
            this.commonDataObject.selectedFormFields?.forEach((e: any) => {
              if (e?.field_values?.length > 0) {
                e.field_values = e?.field_values?.filter((obj: any) => Object.keys(obj)?.length > 0);
              }
              if (e?.field_label?.toLowerCase() == 'year' || e?.field_label?.toLowerCase() == 'years') {
                this.currentFilterYearKey = e?.field_id;
              }
            })
          }
          // this.isLoading = false;
        }
        else {
          // this.isLoading = false;
        }
        this.finalizeLoading();
      },
      (error) => {
        this.showErrorAlert(error.error?.message);
        this.finalizeLoading();
        // this.isLoading = false;
      });
  }

  isNumber(value: any): boolean {
    return !isNaN(value) && value !== null && value !== '' && value !== '-';
  }

  formatValue(value: any): string {
    if (this.isNumber(value)) {
      const num = Number(value);
      return num.toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    }
    return value || '-';
  }

  isTotalRow(row: any): boolean {
    if (!row) return false;
    return Object.values(row).some(v => String(v).toUpperCase().includes('TOTAL'));
  }

  getRowValue(tableName: string, rowIndex: number, key: unknown): any {
    const table: any[] = this.commonDataObject.summaryData[tableName] || [];
    return table[rowIndex]?.[String(key)];
  }

  private removeEmptyFields(rows: unknown): Record<string, any>[] {
    if (!Array.isArray(rows) || rows.length === 0) return rows as any;

    const header = rows[0];
    if (header == null || typeof header !== 'object') return rows;

    const dataRows = rows.slice(1);

    const emptyKeys = Object.keys(header).filter(key =>
      dataRows.every(row =>
        row != null &&
        typeof row === 'object' &&
        (row[key] ?? '').toString().trim() === ''
      )
    );

    return rows.map(row => {
      if (row == null || typeof row !== 'object') return row;
      const copy = { ...row };
      emptyKeys.forEach(key => delete copy[key]);
      return copy;
    });
  }

  cleanResponse(response: any) {
    if (!response || !Array.isArray(response.data) || response.data.length === 0) {
      return response;
    }

    const section = { ...response.data[0] };

    Object.keys(section).forEach(name => {
      section[name] = this.removeEmptyFields(section[name]);
    });

    return {
      ...response,
      data: [section, ...response.data.slice(1)],
    };
  }

  getSummaryData(payload: any) {
    this.currentFilterOnYears = '';
    this.projectService.loading.set(true);
    if (payload?.values?.length > 0) {
      payload?.values.forEach((e: any) => {
        if (e?.field_id === this.currentFilterYearKey) {
          this.currentFilterOnYears = e?.values
        }
      })
    }
    this.commonDataObject.summaryData = {};
    this.commonDataObject.tableKeys = [];
    this.chartData = {};
    this.formulaOptions = [];
    this.formulaRawList = [];
    this.formulaViews = [];
    // this.isLoading = true;
    this.clientService.postAPI(this.commonDataObject.APIObj.FORM_REPORT, payload).subscribe(
      (res: any) => {
        if (res && res.code == 'CSR_MS_OK_200') {
          // this.commonDataObject.summaryData = res.data[0];
          const cleaned = this.cleanResponse(res);
          this.commonDataObject.summaryData = cleaned.data[0];
          const formulaDat = res?.data[1];
          this.commonDataObject.tableKeys = Object.keys(this.commonDataObject.summaryData);
          if (formulaDat?.length > 0) {
            this.formulaOptions = formulaDat.map((f: any) => this.toOption(f));
            this.formulaRawList = formulaDat;
            this.buildFormulaViews();
          }
          const totalTabs = this.commonDataObject.tableKeys.length + this.formulaViews.length;
          if (this.activeTabIndex >= totalTabs) {
            this.activeTabIndex = 0;
          }
          // this.isLoading = false;
          this.prepareChartData();
          this.showSuccessAlert(res.message);
        }
        else {
          this.showErrorAlert(res.message);
          // this.isLoading = false;
        }
        this.finalizeLoading();
      },
      (error) => {
        this.showErrorAlert(error.error?.message);
        this.finalizeLoading();
        // this.isLoading = false;
      });
  }

  prepareChartData() {
    this.commonDataObject.tableKeys.forEach((tableName: any) => {
      const table = this.commonDataObject.summaryData[tableName];
      if (!table || table.length < 2) return;
      const rows = table.slice(1).filter((r: any) => !this.isTotalRow(r));
      if (!rows.length) return;
      const labelMap: { [key: string]: number } = {};
      const headers = table[0];
      let labelKey = '';
      let valueKey = '';
      for (const key of Object.keys(headers)) {
        const sampleValue = rows[0]?.[key];
        if (!labelKey && typeof sampleValue === 'string' && !this.isNumber(sampleValue)) {
          labelKey = key;
        }
        if (this.isNumber(sampleValue)) {
          valueKey = key;
        }
      }
      if (!labelKey || !valueKey) return;

      rows.forEach((r: any) => {
        const label = r[labelKey];
        const value = Number(r[valueKey] || 0);
        if (label && label !== 'TOTAL' && value > 0) {
          labelMap[label] = (labelMap[label] || 0) + value;
        }
      });

      const labels = Object.keys(labelMap);
      const dataValues = Object.values(labelMap);

      if (labels.length > 0) {
        this.chartData[tableName] = {
          labels: labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: this.generateColors(labels.length),
              borderColor: 'white',
              borderWidth: 2,
              hoverOffset: 15,
              hoverBorderColor: '#ffffff',
              hoverBorderWidth: 3
            }
          ]
        };
      }
    });
    this.cdr.detectChanges();
  }

  generateColors(count: number): string[] {
    const colors = [
      '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
      '#06b6d4', '#ec4899', '#14b8a6', '#f97316', '#6366f1',
      '#84cc16', '#0891b2', '#a855f7', '#22c55e', '#eab308'
    ];
    return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
  }

  resetPage() {
    this.commonDataObject.selected_form = {};
    this.commonDataObject.selectedFormFields = [];
    this.commonDataObject.selectedFilters = {};
    this.commonDataObject.summaryData = {};
    this.commonDataObject.tableKeys = [];
    this.chartData = {};
    this.formulaViews = [];
    this.formulaRawList = [];
    this.formulaOptions = [];
    this.activeTabIndex = 0;
    this.showResetFromAnalytics = false;
    this.projectService.reportData.set(null)
  }

  exportExcel() {
    // this.excelExportPopup = true;
    // if (!this.commonDataObject.summaryData || !this.commonDataObject.tableKeys.length) {
    //   this.showErrorAlert('No data available to export');
    //   return;
    // }
    // try {
    //   this.excelService.exportExcel(
    //     this.commonDataObject.summaryData,
    //     this.commonDataObject.selected_form?.form_name || 'Form Report'
    //   );
    //   this.showSuccessAlert('Report exported successfully');
    // } catch (error) {
    //   this.showErrorAlert('Failed to export report');
    // }
    // In your component
    // this.onExport();
  }

  getTabTitle(tableName: string): string {
    if (tableName.includes('_')) {
      return tableName.split('_').map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      ).join(' ');
    }
    return tableName;
  }

  setActiveTab(index: number) {
    this.activeTabIndex = index;
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 50);
  }

  private showSuccessAlert(message: string) {
    this.commonDataObject.apiMeassge = message;
    this.commonDataObject.issuccessAlert = true;
    this.commonDataObject.iserrorAlert = false;
    setTimeout(() => {
      this.commonDataObject.issuccessAlert = false;
    }, 3000);
  }

  private showErrorAlert(message: string) {
    this.commonDataObject.apiMeassge = message;
    this.commonDataObject.iserrorAlert = true;
    this.commonDataObject.issuccessAlert = false;
    setTimeout(() => {
      this.commonDataObject.iserrorAlert = false;
    }, 3000);
  }

  private finalizeLoading() {
    // this.isLoading = true;
    setTimeout(() => {
      this.projectService.loading.set(false);
      this.isLoading = false;
    }, 1000);
  }

  isFilterOpen = false;

  toggleFilterPopover(event: Event): void {
    event.stopPropagation();
    this.isFilterOpen = !this.isFilterOpen;
  }

  closeFilterPopover(): void {
    this.isFilterOpen = false;
  }

  applyFilters(): void {
    this.generatePayload();
    this.closeFilterPopover();
  }

  getActiveFilterCount(): number {
    return Object.values(this.commonDataObject.selectedFilters || {})
      .filter((v: any) => v && v.length > 0).length;
  }

  geToFormSubmission() {
    this.router.navigate(['/form_submission']);
  }

  selectFormat(format: 'years' | 'months'): void {
    this.selectedFormat = format;
  }

  closeExcelExportPopup() {
    this.excelExportPopup = false;
    this.selectedFormat = null;
  }

  submitExcelExport(): void {
    if (!this.selectedFormat) return;

    if (this.selectedFormat === 'years') {
      // Call your years-only export service/method
      console.log('Exporting Years format...');
      // this.excelService.exportYears();
    } else {
      // Call your years & months export service/method
      console.log('Exporting Months format...');
      // this.excelService.exportYearsAndMonths();
    }

    this.closeExcelExportPopup();
  }

  // ===================== Formula tabs =====================

  private toOption(f: any): any {
    const terms = [
      { sign: f.operator_1, name: f.section_1 },
      { sign: f.operator_2, name: f.section_2 },
    ];

    // positive terms first so it reads "expense - income", not "-income + expense"
    terms.sort((a, b) => (a.sign === '+' ? 0 : 1) - (b.sign === '+' ? 0 : 1));

    const expression = terms
      .map((t, i) => {
        if (i === 0) return t.sign === '-' ? `-${t.name}` : t.name;
        return `${t.sign} ${t.name}`;
      })
      .join(' ');

    return {
      label: `${f.formula_title} = ${expression}`,
      value: f.formula_title,
      result: parseFloat(f.value),
    };
  }

  private normalizeKey(s: string): string {
    return (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  // "income" -> matching key in summaryData (case / underscore insensitive)
  private findTableKey(section: string): string | null {
    const target = this.normalizeKey(section);
    const keys = this.commonDataObject.tableKeys;
    return (
      keys.find((k) => this.normalizeKey(k) === target) ??
      keys.find((k) => this.normalizeKey(k).includes(target)) ??
      null
    );
  }

  // reads the number from the TOTAL row of a table
  private getTableTotal(tableKey: string): number | null {
    const table: any[] = this.commonDataObject.summaryData[tableKey] || [];
    const totalRow = table.slice(1).find((r) => this.isTotalRow(r));
    if (!totalRow) return null;
    const nums = Object.values(totalRow)
      .map((v: any) => Number(String(v).replace(/,/g, '')))
      .filter((n) => !isNaN(n));
    return nums.length ? nums[nums.length - 1] : null;
  }

  buildFormulaViews(): void {
    this.formulaViews = this.formulaRawList.map((f) => {
      const opt = this.toOption(f);

      const sections = [
        { name: f.section_1, sign: f.operator_1 },
        { name: f.section_2, sign: f.operator_2 },
      ]
        .sort((a, b) => (a.sign === '+' ? 0 : 1) - (b.sign === '+' ? 0 : 1))
        .map((s) => {
          const key = this.findTableKey(s.name);
          return { ...s, key, total: key ? this.getTableTotal(key) : null };
        });

      const result = opt.result || 0;

      // chart: total of table-1, total of table-2, difference
      const realValues = [sections[0].total ?? 0, sections[1].total ?? 0, result];

      const chart = {
        labels: [
          `${this.getTabTitle(sections[0].name)} Total`,
          `${this.getTabTitle(sections[1].name)} Total`,
          'Loss'
        ],
        datasets: [
          {
            data: realValues.map((v) => Math.abs(v)),
            realValues,
            backgroundColor: [
              '#10b981',
              '#ef4444',
              '#f3de81a6'
            ],
            borderColor: 'white',
            borderWidth: 2,
            hoverOffset: 15
          }
        ]
      };

      return {
        title: f.formula_title,
        label: opt.label,
        sections,
        result,
        chart
      };
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isFilterOpen) return;

    const path = event.composedPath() as HTMLElement[];

    const clickedInside = path.some((el) =>
      el?.classList?.contains('filter-popover-wrapper') ||
      el?.classList?.contains('p-multiselect-overlay') ||
      el?.classList?.contains('custom-multiselect-panel')
    );

    if (!clickedInside) {
      this.closeFilterPopover();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isFilterOpen) this.closeFilterPopover();
  }

  ngOnDestroy(): void {
    this.projectService.reportData.set(null);
    this.resetPage();
  }
}